<template>
  <div id="deliveryCard">
    <span v-if="isPast()">
    </span>

    <span v-else-if="isHoliday() !== undefined">
      <BatchRunListDialog :subheight="300" :year_week_id="item.id"
                          :week_day="week_day" :date_day="item.date_day[week_day - 1]"/>
      <v-card height="105px" width="105px" color="deep-orange darken-1" @click="onClickBadge($event)">
        <v-container>
          {{ isHoliday() }}
        </v-container>
      </v-card>
    </span>
    <span v-else
          class="drop-zone"
          @drop="onDrop($event)"
          @dragover.prevent
          @dragenter.prevent
    >
      <BatchRunListDialog :subheight="300" :year_week_id="item.id"
                          :week_day="week_day" :date_day="item.date_day[week_day - 1]"/>
      <v-card height="105px" width="105px" :color="getCardColor()" @click="onClickBadge($event)"
        :class="getLtClass()"
      >
        <v-container>
          <v-row dense v-for="y in 3" :key="y">
            <v-col dense v-for="x in 4" :key="x" class="px-0">
              <BatchRunBadge
                  v-if="4*(y-1)+(x-1) < item.week_days[week_day - 1].length"
                  :text="getText(x, y)"
                  :item="item.week_days[week_day - 1][4*(y-1)+(x-1)]"
                  :draggable="true"
                  :content="item.week_days[week_day - 1][4*(y-1)+(x-1)].index"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
  </span>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {format, addDays, parseISO} from 'date-fns'
import BatchRunBadge from "@/components/BatchRun/BatchRunBadge";
import BatchRunListDialog from "@/components/BatchRun/BatchRunListDialog";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'BatchRunCard',
  props: ['item', 'week_day'],

  data() {
    return {
      activeCellClass: 'selected-cell',
      hover: false,
    }
  },

  components: {
    BatchRunBadge,
    BatchRunListDialog,
  },
  computed: {
    ...mapFields('BatchRunWeek', ['active_batch_run', 'smd_start_plan', 'smd_end_plan',
        'tht_start_plan', 'tht_end_plan', 'smd_end', 'tht_end', 'lt_mat', 'lt_min']),
  },

  methods: {
    ...mapActions('BatchRunWeek', ['fetchActionItem']),

    onClickBadge(event) {
      // console.log('Clear badge', event, this.item.date_day[this.week_day - 1])
      // console.log(this.smd_start_plan, this.smd_end_plan)
      this.active_batch_run = null
      this.smd_start_plan = null
      this.smd_end_plan = null
      this.tht_start_plan = null
      this.tht_end_plan = null
      this.smd_end = null
      this.tht_end = null
      this.lt_mat = null
      this.lt_min = null
      event.stopPropagation()
    },

    getCardColor() {
      // console.log(this.smd_end, this.tht_end)
      let dt = this.item.date_day[this.week_day - 1]
      if (dt >= this.smd_start_plan && dt <= this.smd_end_plan && !this.smd_end)
          return 'smd_light_color'
      if (dt >= this.tht_start_plan && dt <= this.tht_end_plan && !this.tht_end)
        return 'tht_light_color'
      return 'white'
    },
    getLtClass() {
      // console.log(this.smd_end, this.tht_end)
      let dt = this.item.date_day[this.week_day - 1]
      if (dt === this.lt_mat)
          return 'lt-mat-color'
      if (dt === this.lt_min)
        return 'lt-min-color'
    },

    getPastCardColor() {
      let dt = this.item.date_day[this.week_day - 1]
      if (dt >= this.smd_start_plan && dt <= this.smd_end_plan)
          return 'blue accent-1'
      if (dt >= this.tht_start_plan && dt <= this.tht_end_plan)
        return 'amber accent-1'
      else
          return 'grey lighten-2'
    },

    onDrop(event) {
      let item_id = event.dataTransfer.getData('itemID')
      let parameters = {week_day: this.week_day, dest_item_id: this.item.id}
      this.fetchActionItem({
        action_name: 'set_batch_run_delivery_date',
        id_list: [item_id],
        parameters: parameters
      })
    },
    isHoliday() {
      return this.item.holidays[this.week_day]
    },
    isPast() {
      return this.week_day < this.item.last_post_week_day
    },
    cardColor() {
      return 'grey'
    },
    getBadgeColor(batch_run) {
      if (batch_run.smd > 0 && batch_run.tht > 0)
        return 'purple'
      if (batch_run.tht > 0)
        return 'blue'
      return 'orange'
    },
    getText(x, y) {
      let result_text = this.item.week_days[this.week_day - 1][4 * (y - 1) + (x - 1)].title
      return result_text
    }
  },

  mounted() {
  },

}
</script>

<style scoped lang="scss">

.active-cell {
  background-color: lightgoldenrodyellow;
}

.drop-zone {
  //margin-bottom: 10px;
  //padding: 10px;
}

.drag-el {
  //margin-bottom: 10px;
  //padding: 10px;
}
#deliveryCard .lt-mat-color {
  border-style: solid;
  border-color: darkorange!important;
  border-width: 3px;
}
#deliveryCard .lt-min-color {
  border-style: solid;
  border-color: darkgreen!important;
  border-width: 3px;
}


</style>